import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/*
const firebaseConfig = {
  apiKey: "AIzaSyALoCigtCewpQN9_qGTgQrHZkPUaRDj4GA",
  authDomain: "embajadores-stereo.firebaseapp.com",
  projectId: "embajadores-stereo",
  storageBucket: "embajadores-stereo.firebasestorage.app",
  messagingSenderId: "66777460921",
  appId: "1:66777460921:web:85d3cbd2564608b2922b68",
  measurementId: "G-NJTWLWMFWX"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const analytics = getAnalytics(app);

Notification.requestPermission()
  .then((permission) => {
    if (permission === 'granted') {
      console.log('Notification permission granted.');
      return getToken(messaging);
    } else {
      console.log('Unable to get permission to notify.');
    }
  })
  .then((token) => {
    if (token) {
      console.log('Token');
    }
  })
  .catch((err) => {
    console.log('Error getting permission or token:', err);
  });

onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);
});
*/

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
